import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { EmailArchivePageComponent } from './pages/email-archive-page/email-archive-page.component';

const routes: Routes = [
    {
        path: '',
        component: EmailArchivePageComponent,
    }
];

@NgModule({
    declarations: [],
    imports: [ RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EmailArchiveRoutingModule { }

